/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Mulai_Meta_TitleInputs */

const en_simple_mulai_meta_title = /** @type {(inputs: Simple_Mulai_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start from an idea — Bystep`)
};

const id_simple_mulai_meta_title = /** @type {(inputs: Simple_Mulai_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai dari ide — Bystep`)
};

/**
* | output |
* | --- |
* | "Start from an idea — Bystep" |
*
* @param {Simple_Mulai_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_mulai_meta_title = /** @type {((inputs?: Simple_Mulai_Meta_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Mulai_Meta_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_mulai_meta_title(inputs)
	return en_simple_mulai_meta_title(inputs)
});